// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__107iW","paramInput":"JobSimulator_paramInput__2Yrfd","input":"JobSimulator_input__2ai5w"};